import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Paper,
    TextField,
    FormControl,
    InputLabel,
    MenuItem,
    Button,
    Typography,
    Divider,
    Select,
    Grid,
    Container
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import StoreIcon from '@mui/icons-material/Store';

import { getData, postData } from "../../../../../services/library";
import { UrlApi } from "../../../../../services/apirest";
import CustomBackdrop from "../../../../CustomBackdrop";
import Notify from "../../../../Notify";
import { readonlyContainerSx, readonlyTextFieldSx, readonlyTextFieldVariant } from "../../readonlyFieldStyles";

function FormPeqProveedor(props) {
    const [actividadesMonotributo, setActividadesMonotributo] = useState();
    const [categoriasMonotributo, setCategoriasMonotributo] = useState();
    const [condImpuestoGanancias, setCondImpuestoGanancias] = useState(); //Condicion frente al impuesto de las ganancias
    const [condicionesIva, setCondicionesIva] = useState();

    const [formData, setFormData] = useState(props.edicion && props.proveedor ? {
        nro_cuit: props.proveedor.nro_cuit,
        denominacion: props.proveedor.razon_social,
        impGanancias: props.proveedor.id_sit_ganancias,
        id_condicioniva: props.proveedor.id_condicioniva,
        monotributo: props.proveedor.id_cat_monotributo,
        actividadMonotributo: props.proveedor.id_act_monotributo,
    } : {
        nro_cuit: "",
        denominacion: "",
        impGanancias: "",
        id_condicioniva: "",
        monotributo: "",
        actividadMonotributo: "",
    });


    const [disableForm, setDisableForm] = useState(() => {
        if (props.soloLectura) return true;
        if (props.edicion && props.proveedor) return false;
        return true;
    });
    const [loading, setLoading] = useState(false);
    const [loadingText, setLoadingText] = useState();
    const [disBtn, setDisBtn] = useState(false);

    const limpiarFormulario = () => {
        setFormData((prev) => ({
            ...prev,
            denominacion: "",
            impGanancias: "",
            id_condicioniva: "",
            monotributo: "",
            actividadMonotributo: "",
        }))
    }

    const [notificacion, setNotificacion] = useState({
        open: false
    })

    const handleChange = (field) => (event) => {
        setFormData({ ...formData, [field]: event.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setDisBtn(true)
        if (props.edicion) {
            guardarCambiosProveedor()
        } else {
            guardarNuevoProveedor()
        }
    };

    const guardarNuevoProveedor = async () => {
        const res = await fetch(UrlApi + "/proveedores/simple", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                nro_cuit: formData.nro_cuit,
                razon_social: formData.denominacion,
                es_instalador: 0,
                id_condicionventa: 5,
                observaciones: "Pequeño Proveedor",
                id_condicioniva: formData.id_condicioniva,
                inactivo: 0,
                usuario: localStorage.getItem("user"),
                nombre_fantasia: formData.denominacion,
                id_sit_ganancias: formData.impGanancias,
                id_cat_monotributo: formData.monotributo,
                id_act_monotributo: formData.actividadMonotributo,
                pequeno: 1
            }),

        })
        const json = await res.json();
        if (!!json.id_proveedor) {
            notificarOk();
        } else {
            alert("Error al guardar proveedor.")
            return;
        }
    }


    const guardarCambiosProveedor = async () => {
        const res = await fetch(UrlApi + "/proveedores/" + props.proveedor.id, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                razon_social: formData.denominacion,
                id_condicioniva: formData.id_condicioniva,
                usuario: localStorage.getItem("user"),
                id_sit_ganancias: formData.impGanancias,
                id_cat_monotributo: formData.monotributo,
                id_act_monotributo: formData.actividadMonotributo,
            }),
        })
        const json = await res.json();

        if (json.message === "OK") {
            notificarOk();
        } else {
            alert("Error al guardar proveedor.")
            return;
        }
    }

    const notificarOk = () => {
        setNotificacion({
            open: true,
            mensaje: "Proveedor guardado con exito",
            severity: "success",
            color: "#D4EFDF",
            handleClose: () => {
                props.handleCloseAddProveedor()
            }
        })
    }

    const handleOnClick = async () => {
        setLoading(true)
        const dataExiste = await fetch(UrlApi + "/proveedores/bycuit/" + formData.nro_cuit)
        const existe = await dataExiste.json();

        if (existe?.length > 0) {
            alert(`El proveedor ${formData.nro_cuit} ya existe bajo el nombre ${existe[0].razon_social} ${existe[0]?.nombre_fantasia ? ` (${existe[0].nombre_fantasia})` : ""}`)
            setLoading(false)
            setFormData({
                ...formData,
                nro_cuit: "",
                denominacion: "",
                impGanancias: "",
                id_condicioniva: "",
                monotributo: "",
                actividadMonotributo: "",
            })
            return;
        }
        setLoadingText(`Buscando proveedor CUIT N° ${formData.nro_cuit} en padron de contribuyentes de ARCA...`)
        setFormData({
            ...formData,
            denominacion: "",
            impGanancias: "",
            id_condicioniva: "",
            monotributo: "",
            actividadMonotributo: "",
        })
        const res = await fetch(`${UrlApi}/proveedores_padron/cuit/${formData.nro_cuit}`)
        const json = await res.json()
        if (!!json.length) {
            const prov = json[0]
            setFormData({
                ...formData,
                denominacion: prov.denominacion,
                impGanancias: prov.id_cond_ganancias,
                id_condicioniva: prov.id_condicioniva,
                monotributo: prov.id_categoria_monotibuto,
                actividadMonotributo: prov.id_actividad_monotributo,
            });
            setDisableForm(false)
            setLoading(false)
            return;
        }
        setLoading(false)
        alert(`El cuit ${formData.nro_cuit} no está en la base de datos de arca. Por favor, cargue sus datos.`)
        setDisableForm(false);
    }

    /* ------------------------------------------ EFFECTS ------------------------------------------*/
    useEffect(() => {
        getData("/monotributo_actividades", setActividadesMonotributo);
        getData("/monotributo_categorias", setCategoriasMonotributo);
        getData("/cond_imp_ganancias", setCondImpuestoGanancias);
        getData("/condiciones_iva/formulario_proveedores", setCondicionesIva);
    }, []);

    useEffect(() => {
        if (props.soloLectura && props.proveedor) {
            setDisableForm(true);
            return;
        }
        if (props.edicion && props.proveedor && !props.soloLectura) {
            setDisableForm(false);
            return;
        }
        if (!formData.nro_cuit) {
            limpiarFormulario();
            setDisableForm(true);
        }
    }, [formData.nro_cuit, props.soloLectura, props.proveedor, props.edicion])

    const camposBloqueados = props.soloLectura || disableForm;
    const fieldVariant = props.soloLectura ? readonlyTextFieldVariant : "outlined";
    const fieldSx = props.soloLectura
        ? readonlyTextFieldSx
        : {
            "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                bgcolor: "#fafafa",
                "&:hover": {
                    bgcolor: "#f5f5f5",
                },
                "&.Mui-focused": {
                    bgcolor: "white",
                },
            },
        };

    return (
        <div>
            <Container maxWidth="md" sx={{ pt: 0.5 }}>
                {notificacion.open && (
                    <Notify
                        mensaje={notificacion?.mensaje}
                        open={notificacion?.open}
                        color={notificacion.color}
                        handleClose={notificacion?.handleClose}
                        severity={notificacion?.severity}
                    />
                )}
                <Paper
                    elevation={3}
                    sx={{
                        px: 4,
                        py: 3,
                        borderRadius: 3,
                        border: "1px solid",
                        borderColor: "divider",
                        bgcolor: "white",
                        ...(props.soloLectura ? readonlyContainerSx : {}),
                    }}
                >
                    <Box sx={{ mb: 3 }}>
                        <Box
                            sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}
                        >
                            <Box
                                sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: 2,
                                    bgcolor: "#1976d2",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <StoreIcon sx={{ color: "white", fontSize: 22 }} />
                            </Box>
                            <Typography
                                variant="h5"
                                sx={{ fontWeight: 600, color: "#1a1a1a" }}
                            >
                                {props.titulo}
                            </Typography>
                        </Box>
                        <Typography variant="body2" sx={{ color: "#666", ml: 6.5 }}>
                            {props.soloLectura
                                ? "Datos fiscales del proveedor"
                                : "Complete los datos fiscales del proveedor"}
                        </Typography>
                    </Box>
                    <Divider sx={{ mb: 2 }} />
                    {/* <form onSubmit={handleSubmit}> */}
                    <Grid container spacing={1} mb={2}>
                        <Grid item xs={10} md={10} lg={10}>
                            <TextField
                                disabled={!props.soloLectura && Boolean(props.edicion)}
                                helperText={props.soloLectura ? "" : "Ingrese el CUIT del proveedor SIN GUIONES"}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        handleOnClick();
                                    }
                                }}
                                type="text"
                                size="small"
                                fullWidth
                                label="CUIT"
                                placeholder="xxxxxxxxxxx"
                                value={formData.nro_cuit}
                                onChange={handleChange("nro_cuit")}
                                variant={fieldVariant}
                                {...(props.soloLectura ? { focused: true } : {})}
                                InputProps={{
                                    readOnly: props.soloLectura,
                                }}
                                sx={
                                    props.soloLectura
                                        ? fieldSx
                                        : {
                                            ...fieldSx,
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: 2,
                                                bgcolor: props.edicion ? "#fafafa" : "white",
                                                "&:hover": {
                                                    bgcolor: props.edicion ? "#f5f5f5" : "white",
                                                },
                                                "&.Mui-focused": {
                                                    bgcolor: "white",
                                                },
                                            },
                                        }
                                }
                                onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }}
                                inputProps={{ maxLength: 11 }}
                            />
                        </Grid>
                        {!props.soloLectura ? (
                        <Grid item xs={2} md={2} lg={2}>
                            <Button fullWidth variant="contained" onClick={handleOnClick}
                                disabled={!formData.nro_cuit || formData?.nro_cuit?.length < 11 || props.edicion}
                            >
                                Buscar
                            </Button>
                        </Grid>
                        ) : null}
                        <Grid item xs={12} md={12} lg={12}>
                            <TextField
                                disabled={!props.soloLectura && camposBloqueados}
                                size="small"
                                fullWidth
                                label="Denominación"
                                placeholder="Razón social del proveedor"
                                value={formData.denominacion}
                                onChange={handleChange("denominacion")}
                                variant={fieldVariant}
                                focused
                                InputProps={{
                                    readOnly: props.soloLectura,
                                }}
                                sx={fieldSx}
                            />
                        </Grid>
                        <Grid item xs={6} md={12} lg={6}>
                            <FormControl
                                disabled={camposBloqueados}
                                size="small"
                                fullWidth
                                focused
                                sx={fieldSx}
                            >
                                <InputLabel>Imp. Ganancias</InputLabel>
                                <Select
                                    value={formData.impGanancias}
                                    onChange={handleChange("impGanancias")}
                                    label="Imp. Ganancias"
                                >
                                    {condImpuestoGanancias &&
                                        condImpuestoGanancias.map((condicion) => (
                                            <MenuItem value={condicion.id_cond_imp_ganancias}>
                                                {condicion.condicion}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} md={12} lg={6} >
                            <FormControl
                                disabled={camposBloqueados}
                                fullWidth
                                size="small"
                                focused
                                sx={fieldSx}
                            >
                                <InputLabel>Imp. IVA</InputLabel>
                                <Select
                                    value={formData.id_condicioniva}
                                    onChange={handleChange("id_condicioniva")}
                                    label="Imp. IVA"
                                >
                                    {condicionesIva &&
                                        condicionesIva.map((condicion) => (
                                            <MenuItem value={condicion.id}>
                                                {condicion.descripcion}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} md={12} lg={6} >
                            <FormControl
                                disabled={camposBloqueados}
                                size="small"
                                fullWidth
                                focused
                                sx={fieldSx}
                            >
                                <InputLabel>Monotributo</InputLabel>
                                <Select
                                    value={formData.monotributo}
                                    onChange={handleChange("monotributo")}
                                    label="Monotributo"
                                >
                                    {categoriasMonotributo &&
                                        categoriasMonotributo.map((categoria) => (
                                            <MenuItem value={categoria.id_categoria}>
                                                {categoria.categoria}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} md={12} lg={6}>
                            <FormControl
                                disabled={camposBloqueados}
                                size="small"
                                fullWidth
                                focused
                                sx={fieldSx}
                            >
                                <InputLabel>Actividad Monotributo</InputLabel>
                                <Select
                                    value={formData.actividadMonotributo}
                                    onChange={handleChange("actividadMonotributo")}
                                    label="Actividad Monotributo"
                                >
                                    {actividadesMonotributo &&
                                        actividadesMonotributo.map((actividad) => (
                                            <MenuItem value={actividad.id_actividad}>
                                                {actividad.actividad}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {!props.soloLectura ? (
                    <>
                    <Divider sx={{ my: 3 }} />
                    <Box
                        sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}
                    >
                        <Button
                            variant="outlined"
                            size="large"
                            onClick={props.handleCloseAddProveedor}
                            startIcon={<CloseIcon />}
                            sx={{
                                borderRadius: 2,
                                px: 4,
                                py: 1,
                                textTransform: "none",
                                fontSize: "1rem",
                                fontWeight: 500,
                                borderColor: "#e0e0e0",
                                color: "#666",
                                "&:hover": {
                                    borderColor: "#bdbdbd",
                                    bgcolor: "#fafafa",
                                },
                            }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={handleSubmit}
                            disabled={disBtn || disableForm}
                            variant="contained"
                            size="large"
                            startIcon={<SaveIcon />}
                            sx={{
                                borderRadius: 2,
                                px: 4,
                                py: 1,
                                textTransform: "none",
                                fontSize: "1rem",
                                fontWeight: 500,
                                bgcolor: "#1976d2",
                                boxShadow: "0 4px 12px rgba(25, 118, 210, 0.25)",
                                "&:hover": {
                                    bgcolor: "#1565c0",
                                    boxShadow: "0 6px 16px rgba(25, 118, 210, 0.35)",
                                },
                            }}
                        >
                            {props.textBtn}
                        </Button>
                    </Box>
                    </>
                    ) : null}
                </Paper>
                <CustomBackdrop
                    open={loading}
                    text={loadingText}
                />
            </Container>

        </div>
    )
}

export default FormPeqProveedor;


// import React, { useEffect, useState } from "react";
// import {
//     Box,
//     Paper,
//     TextField,
//     FormControl,
//     InputLabel,
//     MenuItem,
//     Button,
//     Typography,
//     Divider,
//     Select,
//     Grid,
//     Container
// } from "@mui/material";
// import SaveIcon from "@mui/icons-material/Save";
// import CloseIcon from "@mui/icons-material/Close";
// import BusinessIcon from "@mui/icons-material/Business";


// import { getData, postData } from "../../../../../services/library";
// import { UrlApi } from "../../../../../services/apirest";
// import CustomBackdrop from "../../../../CustomBackdrop";
// import Notify from "../../../../Notify"

// function FormPeqProveedor(props) {
//     const [actividadesMonotributo, setActividadesMonotributo] = useState();
//     const [categoriasMonotributo, setCategoriasMonotributo] = useState();
//     const [condImpuestoGanancias, setCondImpuestoGanancias] = useState(); //Condicion frente al impuesto de las ganancias
//     const [condicionesIva, setCondicionesIva] = useState();
//     const [formData, setFormData] = useState(props.edicion && props.proveedor ? {
//         nro_cuit: props.proveedor.nro_cuit,
//         denominacion: props.proveedor.razon_social,
//         impGanancias: props.proveedor.id_sit_ganancias,
//         id_condicioniva: props.proveedor.id_condicioniva,
//         monotributo: props.proveedor.id_cat_monotributo,
//         actividadMonotributo: props.proveedor.id_act_monotributo,
//     } : {
//         nro_cuit: "",
//         denominacion: "",
//         impGanancias: "",
//         id_condicioniva: "",
//         monotributo: "",
//         actividadMonotributo: "",
//     });

//     const [disableForm, setDisableForm] = useState();
//     const [loading, setLoading] = useState(false);
//     const [loadingText, setLoadingText] = useState();
//     const [disBtn, setDisBtn] = useState(false);

//     const limpiarFormulario = () => {
//         setFormData({
//             denominacion: "",
//             impGanancias: "",
//             id_condicioniva: "",
//             monotributo: "",
//             actividadMonotributo: "",
//         })
//     }

//     const [notificacion, setNotificacion] = useState({
//         open: false
//     })

//     const handleChange = (field) => (event) => {
//         setFormData({ ...formData, [field]: event.target.value });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setDisBtn(true)
//         const res = await fetch(UrlApi + "/proveedores/simple", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({
//                 nro_cuit: formData.nro_cuit,
//                 razon_social: formData.denominacion,
//                 es_instalador: 0,
//                 id_condicionventa: 5,
//                 observaciones: "Pequeño Proveedor",
//                 id_situacioniva: formData.id_condicioniva,
//                 inactivo: 0,
//                 usuario: localStorage.getItem("user"),
//                 nombre_fantasia: formData.denominacion,
//                 id_sit_ganancias: formData.impGanancias,
//                 id_cat_monotributo: formData.monotributo,
//                 id_act_monotributo: formData.actividadMonotributo,
//                 pequeno: 1
//             }),

//         })
//         const json = await res.json();
//         if (!!json.id_proveedor) {
//             notificarOk();
//         } else {
//             alert("Error al guardar proveedor.")
//             return;
//         }
//     };

//     const handleOnClick = async () => {
//         setLoading(true)
//         const dataExiste = await fetch(UrlApi + "/proveedores/bycuit/" + formData.nro_cuit)
//         const existe = await dataExiste.json();

//         if (existe?.length > 0) {
//             alert(`El proveedor ${formData.nro_cuit} ya existe bajo el nombre ${existe[0].razon_social} ${existe[0]?.nombre_fantasia ? ` (${existe[0].nombre_fantasia})` : ""}`)
//             setLoading(false)
//             setFormData({
//                 ...formData,
//                 nro_cuit: "",
//                 denominacion: "",
//                 impGanancias: "",
//                 id_condicioniva: "",
//                 monotributo: "",
//                 actividadMonotributo: "",
//             })
//             return;
//         }
//         setLoadingText(`Buscando proveedor CUIT N° ${formData.nro_cuit} en padron de contribuyentes de ARCA...`)
//         setFormData({
//             ...formData,
//             denominacion: "",
//             impGanancias: "",
//             id_condicioniva: "",
//             monotributo: "",
//             actividadMonotributo: "",
//         })
//         const res = await fetch(`${UrlApi}/proveedores_padron/cuit/${formData.nro_cuit}`)
//         const json = await res.json()
//         if (!!json.length) {
//             const prov = json[0]
//             setFormData({
//                 ...formData,
//                 denominacion: prov.denominacion,
//                 impGanancias: prov.id_cond_ganancias,
//                 id_condicioniva: prov.id_condicioniva,
//                 monotributo: prov.id_categoria_monotibuto,
//                 actividadMonotributo: prov.id_actividad_monotributo,
//             });
//             setDisableForm(false)
//             setLoading(false)
//             return;
//         }
//         setLoading(false)
//         alert(`El cuit ${formData.nro_cuit} no está en la base de datos de arca. Por favor, cargue sus datos.`)
//         setDisableForm(false);
//     }

//     /* ------------------------------------------ EFFECTS ------------------------------------------*/
//     useEffect(() => {
//         getData("/monotributo_actividades", setActividadesMonotributo);
//         getData("/monotributo_categorias", setCategoriasMonotributo);
//         getData("/cond_imp_ganancias", setCondImpuestoGanancias);
//         getData("/condiciones_iva/formulario_proveedores", setCondicionesIva);
//     }, []);

//     useEffect(() => {
//         if (!formData.nro_cuit) {
//             limpiarFormulario();
//             setDisableForm(true);
//         }
//     }, [formData.nro_cuit])

//     return (
//         <div>
//             <Container maxWidth="md" sx={{ pt: 0.5 }}>
//                 {notificacion.open && (
//                     <Notify
//                         mensaje={notificacion?.mensaje}
//                         open={notificacion?.open}
//                         color={notificacion.color}
//                         handleClose={notificacion?.handleClose}
//                         severity={notificacion?.severity}
//                     />
//                 )}
//                 <Paper
//                     elevation={0}
//                     sx={{
//                         px: 4,
//                         py: 3,
//                         borderRadius: 3,
//                         border: "1px solid",
//                         borderColor: "divider",
//                         bgcolor: "white",
//                     }}
//                 >
//                     <Box sx={{ mb: 3 }}>
//                         <Box
//                             sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}
//                         >
//                             <Box
//                                 sx={{
//                                     width: 40,
//                                     height: 40,
//                                     borderRadius: 2,
//                                     bgcolor: "#1976d2",
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                 }}
//                             >
//                                 <BusinessIcon sx={{ color: "white", fontSize: 22 }} />
//                             </Box>
//                             <Typography
//                                 variant="h5"
//                                 sx={{ fontWeight: 600, color: "#1a1a1a" }}
//                             >
//                                 Nuevo Proveedor
//                             </Typography>
//                         </Box>
//                         <Typography variant="body2" sx={{ color: "#666", ml: 6.5 }}>
//                             Complete los datos fiscales del proveedor
//                         </Typography>
//                     </Box>
//                     <Divider sx={{ mb: 2 }} />
//                     {/* <form onSubmit={handleSubmit}> */}
//                     <Grid container spacing={1} mb={2}>
//                         <Grid item xs={10} md={10} lg={10}>
//                             <TextField
//                                 helperText={"Ingrese el CUIT del proveedor SIN GUIONES"}
//                                 onKeyDown={(event) => {
//                                     if (event.key === "Enter") {
//                                         handleOnClick();
//                                     }
//                                 }}
//                                 type="text"
//                                 size="small"
//                                 fullWidth
//                                 label="CUIT"
//                                 placeholder="xxxxxxxxxxx"
//                                 value={formData.nro_cuit}
//                                 onChange={handleChange("nro_cuit")}
//                                 sx={{
//                                     "& .MuiOutlinedInput-root": {
//                                         borderRadius: 2,
//                                         bgcolor: "#fafafa",
//                                         "&:hover": {
//                                             bgcolor: "#f5f5f5",
//                                         },
//                                         "&.Mui-focused": {
//                                             bgcolor: "white",
//                                         },
//                                     },
//                                 }}
//                                 onKeyPress={(event) => {
//                                     if (!/[0-9]/.test(event.key)) {
//                                         event.preventDefault();
//                                     }
//                                 }}
//                                 inputProps={{ maxLength: 11 }}
//                             />
//                         </Grid>
//                         <Grid item xs={2} md={2} lg={2}>
//                             <Button fullWidth variant="contained" onClick={handleOnClick}
//                                 disabled={!formData.nro_cuit || formData?.nro_cuit?.length < 11}
//                             >
//                                 Buscar
//                             </Button>
//                         </Grid>
//                         <Grid item xs={12} md={12} lg={12}>
//                             <TextField
//                                 disabled={disableForm}
//                                 size="small"
//                                 fullWidth
//                                 label="Denominación"
//                                 placeholder="Razón social del proveedor"
//                                 value={formData.denominacion}
//                                 onChange={handleChange("denominacion")}
//                                 sx={{
//                                     "& .MuiOutlinedInput-root": {
//                                         borderRadius: 2,
//                                         bgcolor: "#fafafa",
//                                         "&:hover": {
//                                             bgcolor: "#f5f5f5",
//                                         },
//                                         "&.Mui-focused": {
//                                             bgcolor: "white",
//                                         },
//                                     },
//                                 }}
//                             />
//                         </Grid>
//                         <Grid item xs={6} md={12} lg={6}>
//                             <FormControl
//                                 disabled={disableForm}
//                                 size="small"
//                                 fullWidth
//                                 sx={{
//                                     "& .MuiOutlinedInput-root": {
//                                         borderRadius: 2,
//                                         bgcolor: "#fafafa",
//                                         "&:hover": {
//                                             bgcolor: "#f5f5f5",
//                                         },
//                                         "&.Mui-focused": {
//                                             bgcolor: "white",
//                                         },
//                                     },
//                                 }}
//                             >
//                                 <InputLabel>Imp. Ganancias</InputLabel>
//                                 <Select
//                                     value={formData.impGanancias}
//                                     onChange={handleChange("impGanancias")}
//                                     label="Imp. Ganancias"
//                                 >
//                                     {condImpuestoGanancias &&
//                                         condImpuestoGanancias.map((condicion) => (
//                                             <MenuItem value={condicion.id_cond_imp_ganancias}>
//                                                 {condicion.condicion}
//                                             </MenuItem>
//                                         ))}
//                                 </Select>
//                             </FormControl>
//                         </Grid>
//                         <Grid item xs={6} md={12} lg={6} >
//                             <FormControl
//                                 disabled={disableForm}
//                                 fullWidth
//                                 size="small"
//                                 sx={{
//                                     "& .MuiOutlinedInput-root": {
//                                         borderRadius: 2,
//                                         bgcolor: "#fafafa",
//                                         "&:hover": {
//                                             bgcolor: "#f5f5f5",
//                                         },
//                                         "&.Mui-focused": {
//                                             bgcolor: "white",
//                                         },
//                                     },
//                                 }}
//                             >
//                                 <InputLabel>Imp. IVA</InputLabel>
//                                 <Select
//                                     value={formData.id_condicioniva}
//                                     onChange={handleChange("id_condicioniva")}
//                                     label="Imp. IVA"
//                                 >
//                                     {condicionesIva &&
//                                         condicionesIva.map((condicion) => (
//                                             <MenuItem value={condicion.id}>
//                                                 {condicion.descripcion}
//                                             </MenuItem>
//                                         ))}
//                                 </Select>
//                             </FormControl>
//                         </Grid>
//                         <Grid item xs={6} md={12} lg={6} >
//                             <FormControl
//                                 disabled={disableForm}
//                                 size="small"
//                                 fullWidth
//                                 sx={{
//                                     "& .MuiOutlinedInput-root": {
//                                         borderRadius: 2,
//                                         bgcolor: "#fafafa",
//                                         "&:hover": {
//                                             bgcolor: "#f5f5f5",
//                                         },
//                                         "&.Mui-focused": {
//                                             bgcolor: "white",
//                                         },
//                                     },
//                                 }}
//                             >
//                                 <InputLabel>Monotributo</InputLabel>
//                                 <Select
//                                     value={formData.monotributo}
//                                     onChange={handleChange("monotributo")}
//                                     label="Monotributo"
//                                 >
//                                     {categoriasMonotributo &&
//                                         categoriasMonotributo.map((categoria) => (
//                                             <MenuItem value={categoria.id_categoria}>
//                                                 {categoria.categoria}
//                                             </MenuItem>
//                                         ))}
//                                 </Select>
//                             </FormControl>
//                         </Grid>
//                         <Grid item xs={6} md={12} lg={6}>
//                             <FormControl
//                                 disabled={disableForm}
//                                 size="small"
//                                 fullWidth
//                                 sx={{
//                                     "& .MuiOutlinedInput-root": {
//                                         borderRadius: 2,
//                                         bgcolor: "#fafafa",
//                                         "&:hover": {
//                                             bgcolor: "#f5f5f5",
//                                         },
//                                         "&.Mui-focused": {
//                                             bgcolor: "white",
//                                         },
//                                     },
//                                 }}
//                             >
//                                 <InputLabel>Actividad Monotributo</InputLabel>
//                                 <Select
//                                     value={formData.actividadMonotributo}
//                                     onChange={handleChange("actividadMonotributo")}
//                                     label="Actividad Monotributo"
//                                 >
//                                     {actividadesMonotributo &&
//                                         actividadesMonotributo.map((actividad) => (
//                                             <MenuItem value={actividad.id_actividad}>
//                                                 {actividad.actividad}
//                                             </MenuItem>
//                                         ))}
//                                 </Select>
//                             </FormControl>
//                         </Grid>
//                     </Grid>
//                     <Divider sx={{ my: 3 }} />
//                     <Box
//                         sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}
//                     >
//                         <Button
//                             variant="outlined"
//                             size="large"
//                             onClick={props.handleCloseAddProveedor}
//                             startIcon={<CloseIcon />}
//                             sx={{
//                                 borderRadius: 2,
//                                 px: 4,
//                                 py: 1,
//                                 textTransform: "none",
//                                 fontSize: "1rem",
//                                 fontWeight: 500,
//                                 borderColor: "#e0e0e0",
//                                 color: "#666",
//                                 "&:hover": {
//                                     borderColor: "#bdbdbd",
//                                     bgcolor: "#fafafa",
//                                 },
//                             }}
//                         >
//                             Cancelar
//                         </Button>
//                         <Button
//                             onClick={handleSubmit}
//                             disabled={disBtn || disableForm}
//                             variant="contained"
//                             size="large"
//                             startIcon={<SaveIcon />}
//                             sx={{
//                                 borderRadius: 2,
//                                 px: 4,
//                                 py: 1,
//                                 textTransform: "none",
//                                 fontSize: "1rem",
//                                 fontWeight: 500,
//                                 bgcolor: "#1976d2",
//                                 boxShadow: "0 4px 12px rgba(25, 118, 210, 0.25)",
//                                 "&:hover": {
//                                     bgcolor: "#1565c0",
//                                     boxShadow: "0 6px 16px rgba(25, 118, 210, 0.35)",
//                                 },
//                             }}
//                         >
//                             Guardar Proveedor
//                         </Button>
//                     </Box>
//                 </Paper>
//                 <CustomBackdrop
//                     open={loading}
//                     text={loadingText}
//                 />
//             </Container>

//         </div>
//     )
// }

// export default FormPeqProveedor;